// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Yemen from '../_raw/flag/icon_flag_yemen.png';

export default () => <img src={Yemen} alt="Yemen" />;
